import { DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { createMandatoryCategorySelectOption } from 'CorePackage/CatalogsModule/common/createMandatoryCategorySelectOption';
import { IKnmViolatedRequirementsNpa248 } from 'APIPackage/KnmModule/interfaces/IKnmViolatedRequirementsNpa248';

import { convertKnmDataViolationsToFormValues } from './convertKnmDataViolationsToFormValues';
import { IKnmErknmFormViolatedRequirementsNpa } from '../interfaces/IKnmErknmFormViolatedRequirementsNpa';

export function convertKnmDataRequirementsNpaToFormValuesDecision(
  requirementsNpa: IKnmViolatedRequirementsNpa248[] | null | undefined,
): IKnmErknmFormViolatedRequirementsNpa[] | undefined {
  return requirementsNpa?.map<IKnmErknmFormViolatedRequirementsNpa>(item => ({
    guid: item.guid,
    npa: {
      id: item.npaId,
      number: item.number || undefined,
      acceptanceDate: formatDate({
        date: item.acceptanceDate ?? '',
        dateFormat: DATE_FORMAT_LONG_FNS,
        parseFormat: SYSTEM_DATE_FORMAT_FNS,
      }),
      title: item.title || undefined,
    },
    structuralUnit: {
      id: item.structuralUnit.id,
      title: item.structuralUnit.title || undefined,
    },
    violatedMandatory: item.structuralUnit.mandatoryRequirementsViolations
      ? item.structuralUnit.mandatoryRequirementsViolations.map(mandatory => ({
          mandatory: {
            id: mandatory.id,
            title: mandatory.title || '',
          },
          category: mandatory.category ? createMandatoryCategorySelectOption(mandatory.category) : undefined,
          violations: mandatory.violations?.length ? convertKnmDataViolationsToFormValues(mandatory.violations) : null,
        }))
      : [],
    inspectionResults: undefined,
  }));
}
